import { useState } from "react";
import "../styles/SupportTicketFeed.css";

const ticketData = [
  {
    tktId: "tkt-20462",
    tktTitle: "Flag appeal",
    tktUser: "Alex Johnson",
    tktUserCode: "#20462",
    tktSubtitle: '"I didn\'t plagiarise, my code was similar by coincidence"',
    tktTime: "10 min ago",
    tktPriority: "High",
    tktIcon: "⚠",
    tktIconBg: "#FFE8E8",
    tktIconColor: "#E53935",
  },
  {
    tktId: "tkt-18933",
    tktTitle: "Payment issue",
    tktUser: "Sara Kim",
    tktUserCode: "#18933",
    tktSubtitle: "Premium upgrade not reflecting on account",
    tktTime: "1 hr ago",
    tktPriority: "Medium",
    tktIcon: "💳",
    tktIconBg: "#EDE7F6",
    tktIconColor: "#7B1FA2",
  },
  {
    tktId: "tkt-17188",
    tktTitle: "Test score dispute",
    tktUser: "Tom Parker",
    tktUserCode: "#17188",
    tktSubtitle: "Score recalculated, user notified",
    tktTime: "2 hrs ago",
    tktPriority: "Low",
    tktIcon: "📊",
    tktIconBg: "#E8F5E9",
    tktIconColor: "#388E3C",
  },
  {
    tktId: "tkt-34304",
    tktTitle: "Login issue",
    tktUser: "Luna Reyes",
    tktUserCode: "#34304",
    tktSubtitle: "Unable to login after password reset",
    tktTime: "3 hrs ago",
    tktPriority: "Medium",
    tktIcon: "👤",
    tktIconBg: "#FFF3E0",
    tktIconColor: "#E65100",
  },
];

function TktBadge({ priority }) {
  const tktModifier = priority.toLowerCase();
  return (
    <span className={`tkt-badge tkt-badge--${tktModifier}`}>
      {priority}
    </span>
  );
}

function TktIconBox({ icon, bg, color }) {
  return (
    <div
      className="tkt-icon-box"
      style={{ background: bg, color }}
    >
      {icon}
    </div>
  );
}

function TktRow({ ticket }) {
  return (
    <div className="tkt-row">
      <TktIconBox
        icon={ticket.tktIcon}
        bg={ticket.tktIconBg}
        color={ticket.tktIconColor}
      />

      <div className="tkt-text-block">
        <div className="tkt-title-row">
          <span className="tkt-title">{ticket.tktTitle}</span>
          <span className="tkt-username">— {ticket.tktUser}</span>
          <span className="tkt-usercode">{ticket.tktUserCode}</span>
        </div>
        <div className="tkt-meta-row">
          <span className="tkt-subtitle">{ticket.tktSubtitle}</span>
          <span className="tkt-dot">·</span>
          <span className="tkt-time">{ticket.tktTime}</span>
        </div>
      </div>

      <TktBadge priority={ticket.tktPriority} />
    </div>
  );
}

export default function SupportPage() {
  return (
    <div className="tkt-page">
      <div className="tkt-card">
        {ticketData.map((ticket) => (
          <TktRow key={ticket.tktId} ticket={ticket} />
        ))}
      </div>
    </div>
  );
}